/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import store2 from 'store2';
import { useTranslate } from '../../mixins/translate/translate';
import { fetchGet } from '../../store/fetch';
import { PanelBody, PanelButtonLink, PanelHeading, PanelSpacing } from '../elements';
import { Spinner } from '../spinners';
import { IAsset } from '../Surveys/Interfaces/IAsset';
import { DocumentsGrid } from '../utils/DocumentsGrid';
import { DocumentsList } from '../utils/DocumentsList';
import { useReactAsync } from '../utils/useReactAsync';

async function loadDocuments({ batchId }: { batchId: string }) {
    const url = `/api/batches/${batchId}/assets`;
    const result = await fetchGet(url);
    return result.json as IAsset[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BatchDetailsDocuments = (props: { batchId: string }) => {
    const translate = useTranslate();
    const { data, isLoading } = useReactAsync(loadDocuments, { batchId: props.batchId }, []);
    const [isListView, setIsListView] = React.useState({ visible: false, updated: false });

    React.useEffect(() => {
        if (store2.get('BatchDetailsDocumentsListVisible') !== null) {
            setIsListView({ visible: store2.get('BatchDetailsDocumentsListVisible') as boolean, updated: false });
        }
    }, []);

    React.useEffect(() => {
        if (isListView.updated) {
            store2.set('BatchDetailsDocumentsListVisible', isListView.visible);
        }
    }, [isListView]);

    return (
        <>
            <PanelHeading text={translate('survey.documents')} icon="fa fa-book">
                {isListView.visible ? (
                    <PanelButtonLink
                        onClick={() => setIsListView({ visible: false, updated: true })}
                        text={translate('equipment.gridView')}
                        icon="fa fa-th"
                        small={true}
                    />
                ) : (
                    <PanelButtonLink
                        onClick={() => setIsListView({ visible: true, updated: true })}
                        text={translate('equipment.listView')}
                        icon="fa fa-list"
                        small={true}
                    />
                )}
            </PanelHeading>
            <PanelBody noPadding={true}>
                {(isLoading && <Spinner />) || (
                    <>
                        {data && !isListView.visible && (
                            <PanelSpacing>
                                <DocumentsGrid assets={data} />
                            </PanelSpacing>
                        )}
                        {data && isListView.visible && <DocumentsList assets={data} />}
                    </>
                )}
            </PanelBody>
        </>
    );
};
